/**
 * Global AdminTopNav component.
 */

// import primary libararies
import React from 'react';
import PropTypes from 'prop-types';
import { Link, NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

// import third-party libraries
import classNames from 'classnames';

// import components
import Base from '../../../global/components/BaseComponent.js.jsx';
import CloseWrapper from '../../../global/components/helpers/CloseWrapper.js.jsx';
import ProfileDropdownNav from '../../../global/components/navigation/ProfileDropdownNav.js.jsx';
import UserProfilePic from '../../user/components/UserProfilePic.js.jsx';


class AdminTopNav extends Base {
  constructor(props, context) {
    super(props);
    this.state = {
      moreOpen: false
      , profileOpen: false
    }
    this._bind(
      '_openMore'
      , '_openProfile'
      , '_closeDropdowns'
    );
  }

  _openProfile() {
    this.setState({
      profileOpen: true
    });
  }

  _openMore() {
    this.setState({
      moreOpen: true
    });
  }

  _closeDropdowns() {
    this.setState({
      moreOpen: false
      , profileOpen: false
    });
  }

  render() {
    let { loggedInUser } = this.props;
    let { profileOpen } = this.state;

    let pictureUrl = '/img/defaults/profile.png';
    if(loggedInUser && loggedInUser.profilePicUrl) {
      pictureUrl = loggedInUser.profilePicUrl;
    }
    // console.log(pictureUrl);

    let profileImg = { backgroundImage: `url(${pictureUrl})` };
    const agendaUrl = `${window.agendaUrl}/agenda`;
    const dashboardLink = `${window.hubUrl}`

    return(
      <header className="header fixed dashboard-top-nav">
        <div className="topbar">
          <CloseWrapper
            isOpen={(this.state.profileOpen || this.state.moreOpen)}
            closeAction={this._closeDropdowns}
          />
          <div className="titles">
            <NavLink to="/admin" className="nav-logo" >
              <img src="https://pro-ficiency-static.s3.us-east-2.amazonaws.com/atlas/pf_full_white.png"/>
            </NavLink>
          </div>
          <div className="actions">
            <div className="yt-row space-between center-vert">
              <ul className="navigation">
                <li>
                  <a href={agendaUrl} exact={true}>My Agenda</a>
                </li>
                <li>
                  <a href={dashboardLink} >Programs</a>
                </li>
              </ul>
              { loggedInUser && loggedInUser.username ?
                <ul className="dashboard-navigation">
                  <li className="dropdown">
                    <span className="action-link" onClick={this._openProfile}>
                      <UserProfilePic user={loggedInUser} classes='-nav' />
                    </span>
                    <ProfileDropdownNav
                      close={this._closeDropdown}
                      isOpen={this.state.profileOpen}
                    />
                  </li>
                </ul>
                :
                null
              }

            </div>
          </div>
        </div>
      </header>
    )
  }

}

AdminTopNav.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  return {
    loggedInUser: store.user.loggedIn.user
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(AdminTopNav)
);



// WEBPACK FOOTER //
// modules/study/components/StudyDashTopNav.js.jsx